export const LinkOrderType = {
    none: 0,
    trip_number: 1,
    truck_id_and_time: 2,
    truck_and_time: 3,
    trailer_id_and_time: 4,
    trailer_and_time: 5,
    truck_join_and_time: 6,
    trailer_join_and_time: 7
}